<h3 mat-dialog-title>{{ data.title }}</h3>
<div mat-dialog-content>
  <p>{{ data.message }}</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">{{ data.cancelText || 'Hayır' }}</button>
  <button mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>{{ data.confirmText || 'Evet' }}</button>
</div>
